import type { Phase } from "@logic/lib/design"

import { Permission } from "~/graphql/client"
import type { Interlingual } from "~/i18n/types"

export const phaseDescriptionFor: Record<Phase, Interlingual> = {
  "Image Selection": `PhaseDesc_ImageSelection`,
  "Outline": `PhaseDesc_Outline`,
  "Edge Designation": `PhaseDesc_EdgeDesignation`,
  "Roof Attributes": `PhaseDesc_RoofAttributes`,
  "Panel Placement": `PhaseDesc_PanelPlacement`,
  "Panel Activation": `PhaseDesc_PanelActivation`,
}

export const phaseNameFor: Record<Phase, Interlingual> = {
  "Image Selection": `PhaseName_ImageSelection`,
  "Outline": `PhaseName_Outline`,
  "Edge Designation": `PhaseName_EdgeDesignation`,
  "Roof Attributes": `PhaseName_RoofAttributes`,
  "Panel Placement": `PhaseName_PanelPlacement`,
  "Panel Activation": `PhaseName_PanelActivation`,
}

export const SERVICE_BUREAU_PHASES = [
  `Outline`,
  `Edge Designation`,
  `Roof Attributes`,
  `Panel Placement`,
]

export const DESIGNER_PHASES_ADMIN_PERMISSIONS = [
  Permission.vision_admin,
  Permission.admin,
  Permission.vision_designer_user,
  Permission.vision_service_bureau_admin,
  Permission.designer_user,
] as const

export const SERVICE_BUREAU_PHASE_ALLOWED_PERMISSIONS = [
  ...DESIGNER_PHASES_ADMIN_PERMISSIONS,
  Permission.vision_service_bureau_user,
  Permission.service_bureau_user,
]

export const PANEL_ACTIVATION_ALLOWED_PERMISSIONS = [
  ...DESIGNER_PHASES_ADMIN_PERMISSIONS,
  Permission.proposal_creation,
]
